<template>
  <div class="page">
    <div class="top">
      <div class="center">
        <div class="box">
          <div class="left">
            <h1>{{ divlist.device_name }}</h1>
            <h3>{{ divlist.device_type }}</h3>
            <p>
              数据更新时间<span>
                {{
                  toCount.time
                    ? toCount.time.slice(0, 4) +
                      "-" +
                      toCount.time.slice(4, 6) +
                      "-" +
                      toCount.time.slice(6, 8) +
                      " " +
                      toCount.time.slice(8, 10) +
                      ":" +
                      toCount.time.slice(10, 12) +
                      ":" +
                      toCount.time.slice(12, 14)
                    : ""
                }}
              </span>
            </p>
          </div>
          <div class="right">
            <div class="nav">
              <div
                @click="isUd(item.value)"
                v-for="(item, index) in imgurl"
                :key="index"
                :class="{ o78k: item.value === isTr }"
              >
                <img :src="item.url" alt="" />
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pageuser" v-if="isTr == 1">
      <div class="inmain">
        <div class="center">
          <div class="box">
            <div class="left">
              <ul>
                <li>
                  <span>设备名称</span>
                  <span>{{ divlist.device_name }}</span>
                </li>
                <li>
                  <span>持有者</span>
                  <span>{{ divlist.currentUserName }}</span>
                </li>
                <li>
                  <span>公司或学校</span>
                  <span>{{ divlist.currentUserName }}</span>
                </li>
              </ul>
              <div class="in_xian"></div>

              <ul>
                <li>
                  <span>设备地址</span>
                  <span>{{ divlist.address }}</span>
                </li>
                <li>
                  <span>建设时间</span>
                  <span>{{ indextime }}</span>
                </li>
                <li>
                  <span>在线开始时间</span>
                  <span>{{ indextime }}</span>
                </li>
              </ul>
              <div class="in_xian"></div>

              <ul>
                <li>
                  <span>经纬度</span>
                  <span
                    >{{ divlist.position_lng }} ,
                    {{ divlist.position_lat }}</span
                  >
                </li>
                <li>
                  <span>海拔高度</span>
                  <span>{{ divlist.position_alt }}</span>
                </li>
              </ul>
              <div class="in_xian"></div>
              <div class="buttom">
                <div>
                  <el-amap
                    id="amapDemo"
                    v-if="isyes == 1"
                    :center="centersv"
                    :zoom="zoom"
                  >
                    <el-amap-marker
                      :position="divlist._position"
                    ></el-amap-marker>
                  </el-amap>
                  <img src="../../assets/bj-2.jpg" v-if="isyes == 2" alt="" />
                </div>
              </div>
            </div>
            <div class="right">
              <div class="top">
                <div>
                  <div
                    style="
                      text-align: center;
                      margin-bottom: 40px;
                      font-size: 28px;
                      font-weight: bold;
                    "
                  >
                    日数据极值统计(基于分钟)
                  </div>
                  <div
                    v-for="(table, index) in tableList"
                    :key="index"
                    :style="{
                      marginTop: index === 0 ? '0' : '40px',
                      height: '425px',
                      fontSize: '20px',
                    }"
                  >
                    {{ table.title }}
                    <el-table
                      :data="table.data"
                      style="margin-top: 20px; font-size: 18px"
                      height="460"
                      :span-method="arraySpanMethod"
                      border
                    >
                      <el-table-column
                        v-for="(item, key) in table.cols"
                        :key="key"
                        :width="item.width || 'auto'"
                        align="center"
                        :label="item.label"
                      >
                        <template slot-scope="scope">
                          <div v-if="!item.slot">
                            {{ scope.row[item.prop] }}
                          </div>
                          <div v-else>
                            <span
                              :style="{
                                color: item.prop.includes('min')
                                  ? '#0aa1eb'
                                  : 'red',
                              }"
                            >
                              {{ scope.row[item.prop] }}
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="pagemainlist" v-if="isTr == 2">
        <!-- 优化点：使用 isValidData 严谨判断，防止 0 被误判为 false -->
        <div v-if="isValidData(toCount.tempinf)">
          <div
            id="tem_in_chart"
            class="chart"
            style="height: 200px; margin-top: 40px"
          ></div>
          <p>室内温度</p>
        </div>

        <div v-if="isValidData(toCount.tempf)">
          <div
            id="tem_out_chart"
            class="chart"
            style="height: 200px; margin-top: 40px"
          ></div>
          <p>室外温度</p>
        </div>

        <div v-if="isValidData(toCount.humidityin)">
          <v-chart class="chart" :option="chartOption103" />
          <p>室内湿度</p>
        </div>

        <div v-if="isValidData(toCount.humidity)">
          <v-chart class="chart" :option="chartOption104" />
          <p>室外湿度</p>
        </div>

        <div style="margin-top: 20px">
          <div class="znz">
            <div
              class="zhiz"
              :style="{ transform: 'rotate(' + angle.winddir + 'deg)' }"
            ></div>
            <div class="nubone">{{ angle.winddir }}</div>
          </div>
          <p>瞬时风向</p>
        </div>
        <div style="margin-top: 20px">
          <v-chart class="chart" :option="chartOption106" />
          <p>瞬时风速</p>
        </div>
        <div style="margin-top: 20px">
          <div
            id="pre_hour_chart"
            class="chart"
            style="height: 200px; margin-top: 40px"
          ></div>
          <p>降雨量(时)</p>
        </div>

        <div style="width: 300px; margin-top: 20px">
          <div class="circle">
            <div class="inner">
              {{ toCount.solarradiation }}
            </div>
          </div>
          <p>光照(W/m<sup>2</sup>)</p>
        </div>

        <div style="margin-top: 20px">
          <div class="znz">
            <div
              class="zhiz"
              :style="{ transform: 'rotate(' + angle.winddir_avg10m + 'deg)' }"
            ></div>
            <div class="nubone">{{ angle.winddir_avg10m }}</div>
          </div>
          <p>平均风向(10分钟)</p>
        </div>
        <div style="margin-top: 20px">
          <v-chart class="chart" :option="chartOption109" />
          <p>平均风速(2分钟)</p>
        </div>
        <div style="margin-top: 20px">
          <div
            id="pre_day_chart"
            class="chart"
            style="height: 200px; margin-top: 40px"
          ></div>
          <div style="margin-top: 50px">
            <p>降雨量(日)</p>
          </div>
        </div>

        <div style="width: 300px; margin-top: 20px">
          <div class="pyramid">
            <div
              class="pyramid_item"
              v-for="item in 15"
              :key="item"
              :style="{
                backgroundColor:
                  item <= toCount.uv * 1
                    ? item <= 15 && item > 10
                      ? '#a21bd1'
                      : item <= 10 && item > 5
                      ? '#0aa1eb'
                      : '#5b9f49'
                    : '#ebebeb',
              }"
            ></div>
          </div>
          <div style="text-align: center; margin-top: 20px; font-size: 18px">
            当前等级:{{ toCount.uv }}
          </div>
          <p>UV(紫外线强度)</p>
        </div>
        <div style="width: 300px; height: 300px; margin-top: 20px">
          <div class="circle">
            <div class="inner">
              {{ toCount.baromabsin }}
            </div>
          </div>
          <p>气压(hPa)</p>
        </div>
      </div>
    </div>

    <div class="pagedata" v-if="isTr == 3">
      <div class="center">
        <div class="btn">
          <div>
            <el-button
              :type="period === type.type ? 'primary' : ''"
              v-for="(type, index) in type_list"
              :key="index"
              @click="changTime(type.type)"
              >{{ type.name }}</el-button
            >
          </div>
        </div>

        <div class="from" v-for="(item, index) of charts" :key="index">
          <div class="title">
            <h3>{{ item.name }}</h3>
          </div>
          <v-chart class="chart" :option="item" key="" :autoresize="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { $device } from "@/services";
import { windDegreeToDir } from "@/utils/wind";
const icon1 = require("@/assets/gis-SDS/nav-02.svg");
import "echarts-liquidfill";
import chart from "./mixins/chart.vue";

const SAVE_ICON_B64 =
  "image://data:image/png;base64,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";
const POINTER_ICON =
  "path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z";

const createChartConfig = (
  that,
  { name, legend, unit, leftGrid, series, customFormatter }
) => {
  return {
    name,
    legend: legend
      ? {
          right: 135,
          top: 20,
          inactiveColor: "#9fa0a0",
          textStyle: { fontSize: 14, color: "#9fa0a0" },
          data: legend,
        }
      : { show: false, data: [name] },
    xAxis: {
      boundaryGap: false,
      type: "category",
      data: [],
      axisLabel: {
        inside: false,
        color: "#9FA0A0",
        formatter: function (value) {
          let i;
          switch (that.period) {
            case "month":
              i = dayjs(value).format("DD");
              break;
            case "week":
              i = dayjs(value).format("DD日HH时");
              break;
            case "day":
              i = dayjs(value).format("HH时");
              break;
          }
          return i;
        },
      },
      axisLine: { onZero: false },
    },
    yAxis: { scale: true },
    grid: { bottom: "100px", left: leftGrid || "2%", right: "2%" },
    tooltip: {
      backgroundColor: "#00A0E9",
      textStyle: { fontSize: 16, color: "#FFFFFF" },
      trigger: "axis",
      formatter:
        customFormatter ||
        function (params) {
          let title = `${params[0].axisValue.slice(
            0,
            4
          )}年${params[0].axisValue.slice(4, 6)}月${params[0].axisValue.slice(
            6,
            8
          )}日${params[0].axisValue.slice(8, 10)}时${params[0].axisValue.slice(
            10,
            12
          )}分<br/>`;
          let body = params
            .map((p, i) => {
              let label = legend ? legend[i] : name.split("(")[0];
              if (name === "温度(℃)")
                label = legend[i].includes("室内") ? "室内温度" : "室外温度";
              if (name === "湿度(%)")
                label = legend[i].includes("室内") ? "室内湿度" : "室外湿度";
              return `${label}：${p.value || "--"}${unit}<br/>`;
            })
            .join("");
          return title + body;
        },
    },
    toolbox: {
      show: true,
      orient: "horizontal",
      right: 80,
      top: 15,
      itemSize: 20,
      feature: { saveAsImage: { show: true, icon: SAVE_ICON_B64 } },
    },
    series,
  };
};

const createGauge = (type, params = {}) => {
  const base = { type: "gauge", data: [{ value: 0 }] };
  if (type === "temp") {
    return {
      series: [
        {
          ...base,
          center: ["50%", "60%"],
          startAngle: 200,
          endAngle: -20,
          min: -40,
          max: 60,
          splitNumber: 10,
          itemStyle: { color: "red" },
          progress: { show: true, width: 10 },
          pointer: { show: false },
          axisLine: { lineStyle: { width: 10 } },
          axisTick: {
            distance: -10,
            splitNumber: 5,
            lineStyle: { width: 2, color: "#999" },
          },
          splitLine: {
            distance: -10,
            length: 8,
            lineStyle: { width: 3, color: "#999" },
          },
          axisLabel: { distance: -20, color: "#999", fontSize: 15 },
          anchor: { show: false },
          title: { show: false },
          detail: {
            valueAnimation: true,
            width: "60%",
            lineHeight: 40,
            borderRadius: 8,
            offsetCenter: [0, "-15%"],
            fontSize: 30,
            fontWeight: "bolder",
            formatter: "{value} °C",
            color: "inherit",
          },
        },
      ],
    };
  } else if (type === "humid") {
    return {
      series: [
        {
          ...base,
          center: ["50%", "60%"],
          startAngle: 200,
          endAngle: -20,
          min: 0,
          max: 100,
          splitNumber: 10,
          itemStyle: { color: "#FFAB91" },
          progress: { show: true, width: 10 },
          pointer: { show: false },
          axisLine: { lineStyle: { width: 10 } },
          axisTick: {
            distance: 5,
            splitNumber: 5,
            lineStyle: { width: 2, color: "#999" },
          },
          splitLine: {
            distance: 5,
            length: 14,
            lineStyle: { width: 3, color: "#999" },
          },
          axisLabel: { distance: 20, color: "#999", fontSize: 10 },
          anchor: { show: false },
          title: { show: false },
          detail: {
            valueAnimation: true,
            width: "60%",
            lineHeight: 40,
            borderRadius: 8,
            offsetCenter: [0, "-15%"],
            fontSize: 30,
            fontWeight: "bolder",
            formatter: "{value} %",
            color: "inherit",
          },
        },
      ],
    };
  } else if (type === "simple") {
    return {
      series: [
        {
          ...base,
          min: 0,
          max: params.max || 100,
          name: "Pressure",
          detail: { formatter: "{value}" },
          data: [{ value: "", name: params.name || "" }],
        },
      ],
    };
  } else if (type === "rain") {
    return {
      series: [
        {
          ...base,
          startAngle: 360,
          endAngle: 0,
          min: 0,
          max: params.max || 10,
          splitNumber: 10,
          itemStyle: {
            color: "#58D9F9",
            shadowColor: "rgba(0,138,255,0.45)",
            shadowBlur: 10,
            shadowOffsetX: 2,
            shadowOffsetY: 2,
          },
          progress: { show: true, roundCap: true, width: 18 },
          pointer: {
            icon: POINTER_ICON,
            length: "75%",
            width: 16,
            offsetCenter: [0, "5%"],
          },
          axisLine: { roundCap: true, lineStyle: { width: 18 } },
          axisTick: { splitNumber: 2, lineStyle: { width: 2, color: "#999" } },
          splitLine: { length: 12, lineStyle: { width: 3, color: "#999" } },
          axisLabel: { distance: 30, color: "#999", fontSize: 20 },
          title: { show: false },
          detail: {
            backgroundColor: "#fff",
            borderColor: "#999",
            borderWidth: 2,
            width: "60%",
            lineHeight: 50,
            height: 40,
            borderRadius: 8,
            offsetCenter: [0, "35%"],
            valueAnimation: true,
            formatter: function (val) {
              return "{value|" + val.toFixed(0) + "}{unit|mm}";
            },
            rich: {
              value: { fontSize: 50, fontWeight: "bolder", color: "#777" },
              unit: { fontSize: 20, color: "#999", padding: [0, 0, -20, 10] },
            },
          },
        },
      ],
    };
  } else if (type === "uv") {
    return {
      series: [
        {
          ...base,
          min: 0,
          max: params.max || 15,
          axisLine: {
            lineStyle: {
              width: 30,
              color: [
                [0.3, "#67e0e3"],
                [0.7, "#37a2da"],
                [1, "#fd666d"],
              ],
            },
          },
          pointer: { itemStyle: { color: "inherit" } },
          axisTick: {
            distance: -30,
            length: 8,
            lineStyle: { color: "#fff", width: 2 },
          },
          splitLine: {
            distance: -30,
            length: 30,
            lineStyle: { color: "#fff", width: 4 },
          },
          axisLabel: { color: "inherit", distance: 40, fontSize: 20 },
          detail: {
            valueAnimation: true,
            formatter: "{value} ",
            color: "inherit",
          },
        },
      ],
    };
  }
};

export default {
  name: "gisSiteDetails",
  mixins: [chart],
  data() {
    let that = this;
    let dayjs_time_format = "YYYYMMDDHHmm00";
    let centersv = [110, 30];

    let pastChartOption = {
      name: "数据总览",
      textStyle: { color: "#666666", fontSize: 10 },
      title: {
        text: "",
        left: "center",
        top: 0,
        textStyle: { color: "#666666", fontSize: 14 },
      },
      tooltip: { trigger: "axis" },
      toolbox: {
        show: true,
        orient: "horizontal",
        right: 80,
        top: 15,
        itemSize: 20,
        feature: { saveAsImage: { show: true, icon: SAVE_ICON_B64 } },
      },
      grid: { bottom: 40, top: 60, left: 40, right: 240 },
      legend: {
        data: ["温度", "湿度", "光照", "降雨", "气压", "风速"],
        right: 185,
        top: 20,
        textStyle: { color: "#666666" },
      },
      dataZoom: [
        { type: "slider", show: true, xAxisIndex: 0, start: 0, end: 100 },
        { type: "inside", xAxisIndex: 0 },
      ],
      xAxis: [
        {
          type: "category",
          data: [],
          axisLabel: {
            inside: false,
            color: "#9FA0A0",
            formatter: function (value) {
              let i;
              switch (that.period) {
                case "month":
                  i = dayjs(value).format("DD");
                  break;
                case "week":
                  i = dayjs(value).format("DD日HH时");
                  break;
                case "day":
                  i = dayjs(value).format("HH时");
                  break;
              }
              return i;
            },
          },
          tooltip: {
            valueFormatter: (value) => dayjs(value).format("DD日HH时"),
          },
          axisPointer: { type: "shadow" },
          axisLine: { lineStyle: { color: "#666666" } },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: "温度（°C）",
          position: "left",
          nameLocation: "middle",
          nameGap: 25,
          axisLine: { show: true, lineStyle: { color: "#666" } },
          axisTick: { show: true },
          scale: true,
        },
        {
          type: "value",
          name: "湿度（%）",
          nameGap: 25,
          position: "right",
          offset: 0,
          nameLocation: "middle",
          axisLine: { show: true, lineStyle: { color: "#666" } },
          axisTick: { show: false },
        },
        {
          type: "value",
          name: "光照（m/s）",
          nameGap: 25,
          position: "right",
          offset: 40,
          nameLocation: "middle",
          axisLine: { show: true, lineStyle: { color: "#666" } },
          axisTick: { show: false },
        },
        {
          type: "value",
          name: "降雨（mm）",
          nameGap: 25,
          position: "right",
          offset: 80,
          nameLocation: "middle",
          axisLine: { show: true, lineStyle: { color: "#666" } },
          axisTick: { show: false },
        },
        {
          type: "value",
          name: "气压（hPa）",
          nameGap: 45,
          position: "right",
          offset: 120,
          nameLocation: "middle",
          axisLine: { show: true, lineStyle: { color: "#666" } },
          axisTick: { show: false },
          scale: true,
        },
        {
          type: "value",
          name: "风速（m/s）",
          nameGap: 35,
          position: "right",
          offset: 180,
          nameLocation: "middle",
          axisLine: { show: true, lineStyle: { color: "#666" } },
          axisTick: { show: false },
        },
      ],
      series: [
        {
          name: "温度",
          type: "line",
          lineStyle: { color: "#f68227" },
          itemStyle: { color: "#f68227" },
          tooltip: { valueFormatter: (v) => v + "°C" },
          data: [],
        },
        {
          name: "湿度",
          type: "line",
          data: [],
          tooltip: { valueFormatter: (v) => v + "%" },
          yAxisIndex: 1,
        },
        {
          name: "光照",
          type: "line",
          data: [],
          tooltip: { valueFormatter: (v) => v + "W/m^2" },
          yAxisIndex: 2,
        },
        {
          name: "降雨",
          type: "bar",
          barWidth: 20,
          yAxisIndex: 3,
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "#0AB1E4" },
                { offset: 1, color: "#3AB87F" },
              ],
              global: false,
            },
          },
          tooltip: { valueFormatter: (v) => v + "mm" },
          data: [],
        },
        {
          name: "气压",
          type: "line",
          yAxisIndex: 4,
          tooltip: { valueFormatter: (v) => v + "hPa" },
          data: [],
        },
        {
          name: "风速",
          type: "line",
          data: [],
          smooth: true,
          lineStyle: { color: "green" },
          tooltip: { valueFormatter: (v) => v + "m/s" },
          yAxisIndex: 5,
        },
      ],
    };

    return {
      imgurl: [
        {
          url: require("@/assets/gis-SDS/nav-02.svg"),
          name: "详细数据",
          value: 2,
        },
        { url: icon1, name: "站点信息", value: 1 },
        {
          url: require("@/assets/gis-SDS/nav-03.svg"),
          name: "历史数据",
          value: 3,
        },
      ],
      dayjs_time_format,
      centersv,
      angle: { winddir: 0, winddir_avg10m: 0 },
      type_list: [
        { name: "日数据", type: "day" },
        { name: "周数据", type: "week" },
      ],
      isyes: 1,
      isTr: 2,
      zoom: 10,
      device_name: "",
      device_type: "",
      remarks: "",
      jindu: "",
      wendu: "",
      addres: "",
      currentUserNamesss: "",
      alt: "",
      indextime: "",
      divlist: { _position: centersv },
      checkTime: dayjs().subtract(2, "minute").format(dayjs_time_format),
      startTime: dayjs().subtract(2, "minute").format(dayjs_time_format),
      endTime: dayjs().format(dayjs_time_format),
      timerange: [
        dayjs().subtract(1, "d").format(dayjs_time_format),
        dayjs().format(dayjs_time_format),
      ],
      period: "day",
      deviceData: {},

      charts: {
        pastChartOption,
        chartOption1: createChartConfig(that, {
          name: "温度(℃)",
          legend: ["温度(室内)(℃)", "温度(室外)(℃)"],
          unit: "℃",
          series: [
            { name: "温度(室内)(℃)", type: "line", smooth: true, data: [] },
            { name: "温度(室外)(℃)", type: "line", smooth: true, data: [] },
          ],
        }),
        chartOption2: createChartConfig(that, {
          name: "湿度(%)",
          legend: ["湿度(室内)(%)", "湿度(室外)(%)"],
          unit: "%",
          series: [
            { name: "湿度(室内)(%)", type: "line", smooth: true, data: [] },
            { name: "湿度(室外)(%)", type: "line", smooth: true, data: [] },
          ],
        }),
        chartOption3: createChartConfig(that, {
          name: "气压(hPa)",
          legend: ["气压(hpa)"],
          unit: "hPa",
          leftGrid: "40",
          series: [{ name: "气压(hPa)", type: "line", smooth: true, data: [] }],
        }),
        chartOption4: createChartConfig(that, {
          name: "风速(m/s)",
          unit: "m/s",
          series: [{ name: "风速(m/s)", type: "line", smooth: true, data: [] }],
        }),
        chartOption41: createChartConfig(that, {
          name: "风向(°)",
          unit: "",
          leftGrid: "40",
          series: [{ name: "风向(°)", type: "line", smooth: true, data: [] }],
          customFormatter: function (params) {
            let dir =
              params[0].value === ""
                ? ""
                : windDegreeToDir(params[0].value || "--");
            return `${params[0].axisValue.slice(
              0,
              4
            )}年${params[0].axisValue.slice(4, 6)}月${params[0].axisValue.slice(
              6,
              8
            )}日${params[0].axisValue.slice(
              8,
              10
            )}时${params[0].axisValue.slice(10, 12)}分<br/>风向：${dir}<br/>`;
          },
        }),
        chartOption5: createChartConfig(that, {
          name: "降雨(mm)",
          unit: "mm",
          series: [
            {
              name: "降雨(mm)",
              type: "bar",
              smooth: true,
              barWidth: "30%",
              data: [],
              itemStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    { offset: 0, color: "#0AB1E4" },
                    { offset: 1, color: "#3AB87F" },
                  ],
                  global: false,
                },
              },
            },
          ],
        }),
        chartOption6: createChartConfig(that, {
          name: "光照(W/m^2)",
          unit: "W/m^2",
          leftGrid: "40",
          series: [
            { name: "光照(W/m^2)", type: "line", smooth: true, data: [] },
          ],
        }),
        chartOption7: createChartConfig(that, {
          name: "UV",
          unit: "",
          series: [{ name: "UV", type: "line", smooth: true, data: [] }],
        }),
      },

      chartOption101: createGauge("temp"),
      chartOption102: createGauge("temp"),
      chartOption103: createGauge("humid"),
      chartOption104: createGauge("humid"),
      chartOption105: createGauge("simple", { max: 5000, name: "风向" }),
      chartOption106: createGauge("simple", { max: 100 }),
      chartOption107: createGauge("simple", { max: 100, name: "风向" }),
      chartOption108: createGauge("simple", { max: 100, name: "风向" }),
      chartOption109: createGauge("simple", { max: 100 }),

      chartOption110: {
        series: [
          {
            type: "gauge",
            startAngle: 90,
            endAngle: -270,
            pointer: { show: false },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: { borderWidth: 1, borderColor: "#464646" },
            },
            axisLine: { lineStyle: { width: 10 } },
            splitLine: { show: false, distance: 0, length: 10 },
            axisTick: { show: false },
            axisLabel: { show: false, distance: 50 },
            data: [
              {
                value: "0",
                name: "相对气压",
                title: { offsetCenter: ["0%", "-55%"] },
                detail: { valueAnimation: true, offsetCenter: ["0%", "-25%"] },
              },
              {
                value: 0,
                name: "绝对气压",
                title: { offsetCenter: ["0%", "20%"] },
                detail: { valueAnimation: true, offsetCenter: ["0%", "50%"] },
              },
            ],
            title: { fontSize: 20 },
            detail: {
              width: 100,
              height: 20,
              fontSize: 15,
              color: "inherit",
              borderColor: "inherit",
              borderRadius: 10,
              borderWidth: 2,
              formatter: "{value}hPa",
            },
          },
        ],
      },

      chartOption111: createGauge("rain", { max: 10 }),
      chartOption112: createGauge("rain", { max: 100 }),
      chartOption113: createGauge("rain", { max: 1000 }),
      chartOption114: createGauge("rain", { max: 1000 }),
      chartOption115: createGauge("rain", { max: 1000 }),
      chartOption116: createGauge("rain", { max: 1000 }),
      chartOption117: createGauge("uv", { max: 15 }),
      chartOption118: createGauge("uv", { max: 200 }),

      toCount: {},
      timeSdata: null,
      deviceid: null,
      todayTableList: [],
      yesTableList: [],
      todayCol: [
        { prop: "name", label: dayjs().format("YYYY-MM-DD"), width: "180px" },
        { prop: "minNum", label: "最低", slot: true },
        { prop: "minTime", label: "出现时间", slot: true, width: "100px" },
        { prop: "maxNum", label: "最高", slot: true },
        { prop: "maxTime", label: "出现时间", slot: true, width: "100px" },
        { prop: "avg", label: "平均值" },
      ],
      yesCol: [
        {
          prop: "name",
          label: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
          width: "180px",
        },
        { prop: "minNum", label: "最低", slot: true },
        { prop: "minTime", label: "出现时间", slot: true, width: "100px" },
        { prop: "maxNum", label: "最高", slot: true },
        { prop: "maxTime", label: "出现时间", slot: true, width: "100px" },
        { prop: "avg", label: "平均值" },
      ],
      timer: null,
    };
  },
  computed: {
    tableList() {
      return [
        {
          title: "今天（截至目前）",
          data: this.todayTableList,
          cols: this.todayCol,
        },
        {
          title: "昨天日数据(降雨数据为累计值)",
          data: this.yesTableList,
          cols: this.yesCol,
        },
      ];
    },
  },
  created() {
    let device = this.$route.query.device;
    this.deviceid = this.$route.query.device;
    if (device) {
      this.$nextTick(() => {
        this.getmain(device);
        this.getuser(device);
        this.getLatestData(device);
        this.getYesTableData(device);
      });
    }
    this.maindatatime();
    this.timer = setInterval(() => {
      if (device) {
        this.getmain(device);
        this.getuser(device);
        this.getLatestData(device);
      }
      this.maindatatime();
    }, 13000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    windDegreeToDir,
    // 核心优化方法：更严谨地判断数据有效性，避免 0 被当作 false 的情况
    isValidData(val) {
      return val !== undefined && val !== null && val !== "";
    },
    arraySpanMethod({ rowIndex }) {
      if (rowIndex === 6) {
        return [1, 3];
      }
    },
    maindatatime() {
      this.timeSdata = dayjs().format("YYYY-MM-DD HH:mm:ss");
    },
    btnmm(value) {
      this.isyes = value;
    },
    isUd(value) {
      this.isTr = value;
      if (this.isTr === 2) {
        this.$nextTick(() => {
          // 优化点：在初始化 Echarts 前先检查挂载的 DOM 是否存在，防止因为 v-if 隐藏了元素而报错导致阻塞后续代码
          if (document.getElementById("tem_in_chart")) {
            this.drawteminCharts(
              "tem_in_chart",
              Number.isInteger(this.toCount.tempinf)
                ? this.toCount.tempinf.toFixed(1)
                : this.toCount.tempinf
            );
          }
          if (document.getElementById("tem_out_chart")) {
            this.drawteminCharts(
              "tem_out_chart",
              Number.isInteger(this.toCount.tempf)
                ? this.toCount.tempf.toFixed(1)
                : this.toCount.tempf
            );
          }
          if (document.getElementById("pre_hour_chart")) {
            this.drawPre("pre_hour_chart", this.toCount.hourlyrainin, 10);
          }
          if (document.getElementById("pre_day_chart")) {
            this.drawPre("pre_day_chart", this.toCount.dailyrainin, 100);
          }
        });
      }
      if (this.isTr === 3) {
        this.getHistory(this.deviceid);
      }
    },
    changTime(value) {
      this.period = value;
      let start = dayjs().subtract(1, value).format(this.dayjs_time_format),
        end = dayjs().format(this.dayjs_time_format);
      this.timerange = [start, end];
      this.getHistory(this.deviceid);
    },

    getmain(device) {
      return $device.getDeviceData({ device }).then((res) => {
        res.barMaxTime =
          (res.barMaxTime + "").slice(8, 10) +
          ":" +
          (res.barMaxTime + "").slice(10, 12);
        res.barMinTime =
          (res.barMinTime + "").slice(8, 10) +
          ":" +
          (res.barMinTime + "").slice(10, 12);
        res.humMaxTime =
          (res.humMaxTime + "").slice(8, 10) +
          ":" +
          (res.humMaxTime + "").slice(10, 12);
        res.humMinTime =
          (res.humMinTime + "").slice(8, 10) +
          ":" +
          (res.humMinTime + "").slice(10, 12);
        res.windMaxTime =
          (res.windMaxTime + "").slice(8, 10) +
          ":" +
          (res.windMaxTime + "").slice(10, 12);
        res.windMinTime =
          (res.windMinTime + "").slice(8, 10) +
          ":" +
          (res.windMinTime + "").slice(10, 12);
        res.solarMaxTime =
          (res.solarMaxTime + "").slice(8, 10) +
          ":" +
          (res.solarMaxTime + "").slice(10, 12);
        res.solarMinTime =
          (res.solarMinTime + "").slice(8, 10) +
          ":" +
          (res.solarMinTime + "").slice(10, 12);
        res.temMaxTime =
          (res.temMaxTime + "").slice(8, 10) +
          ":" +
          (res.temMaxTime + "").slice(10, 12);
        res.temMinTime =
          (res.temMinTime + "").slice(8, 10) +
          ":" +
          (res.temMinTime + "").slice(10, 12);
        res.uvMaxTime =
          (res.uvMaxTime + "").slice(8, 10) +
          ":" +
          (res.uvMaxTime + "").slice(10, 12);
        res.uvMinTime =
          (res.uvMinTime + "").slice(8, 10) +
          ":" +
          (res.uvMinTime + "").slice(10, 12);
        res.time = res.time + "";
        this.toCount = res;
        let maxArr = [];
        maxArr.push({
          name: "气温(°C)",
          maxNum: res.temMax,
          minNum: res.temMin,
          maxTime: res.temMaxTime,
          minTime: res.temMinTime,
          avg: res.temAvg.toFixed(1),
        });
        maxArr.push({
          name: "湿度(%)",
          maxNum: res.humMax,
          maxTime: res.humMaxTime,
          minNum: res.humMin,
          minTime: res.humMinTime,
          avg: res.humAvg.toFixed(1),
        });
        maxArr.push({
          name: "气压(hPa)",
          maxNum: res.barMax,
          maxTime: res.barMaxTime,
          minNum: res.barMin,
          minTime: res.barMinTime,
          avg: res.barAvg.toFixed(1),
        });
        maxArr.push({
          name: "风速(m/s)",
          maxNum: res.windMax,
          maxTime: res.windMaxTime,
          minNum: res.windMin,
          minTime: res.windMinTime,
          avg: res.windAvg.toFixed(1),
        });
        maxArr.push({
          name: "太阳辐射(W/m²)",
          maxNum: res.solarMax,
          maxTime: res.solarMaxTime,
          minNum: res.solarMin,
          minTime: res.solarMinTime,
          avg: res.solarAvg.toFixed(1),
        });
        maxArr.push({
          name: "紫外线强度(0-15)",
          maxNum: res.uvMax,
          maxTime: res.uvMaxTime,
          minNum: res.uvMin,
          minTime: res.uvMinTime,
          avg: res.uvAvg.toFixed(1),
        });
        maxArr.push({
          name: "当天降雨(mm)",
          maxNum: res.dailyrainin,
          maxTime: res.dailyrainin,
          minNum: res.dailyrainin,
          minTime: res.dailyrainin,
          avg: res.dailyrainin,
        });
        this.todayTableList = maxArr;
        this.isUd(this.isTr);
      });
    },

    getuser(device) {
      return $device.getConnectData({ device: device }).then((res) => {
        let data = res.data?.[0] || {};
        let _position = [data.position_lng, data.position_lat];
        this.divlist = { ...data, _position };
        this.centersv = _position;
      });
    },

    getLatestData(device) {
      return $device
        .getDeviceData({
          device,
          startTime: this.startTime,
          endTime: this.endTime,
        })
        .then((res) => {
          let d = res;
          d.time = d.time + "";
          this.chartOption101.series[0].data[0].value = d.tempinf || 0;
          this.chartOption102.series[0].data[0].value = d.tempf || 0;
          this.chartOption103.series[0].data[0].value = d.humidityin || 0;
          this.chartOption104.series[0].data[0].value = d.humidity || 0;
          this.chartOption110.series[0].data[0].value = d.baromrelin || 0;
          this.chartOption110.series[0].data[1].value = d.baromabsin || 0;
          this.chartOption105.series[0].data[0].value = d.winddir || 0;
          this.angle.winddir = d.winddir || 0;
          this.angle.winddir_avg10m = d.winddir10m || 0;
          this.chartOption107.series[0].data[0].value = d.windspdmph_avg2m || 0;
          this.chartOption106.series[0].data[0].value = d.windspeedmph || 0;
          this.chartOption109.series[0].data[0].value = d.windgustmph || 0;
          this.chartOption108.series[0].data[0].value = d.maxdailygust || 0;
          this.chartOption111.series[0].data[0].value = d.hourlyrainin || 0;
          this.chartOption112.series[0].data[0].value = d.dailyrainin || 0;
          this.chartOption113.series[0].data[0].value = d.weeklyrainin || 0;
          this.chartOption114.series[0].data[0].value = d.monthlyrainin || 0;
          this.chartOption115.series[0].data[0].value = d.yearlyrainin || 0;
          this.chartOption116.series[0].data[0].value = d.totalrainin || 0;
          this.chartOption117.series[0].data[0].value = d.uv || 0;
          this.chartOption118.series[0].data[0].value = d.solarradiation || 0;

          this.deviceData = {
            ...d,
            device: this.divlist.device,
            currentUserName: this.divlist.currentUserName,
            device_name: this.divlist.device_name,
            device_type: this.divlist.device_type,
            lng: this.divlist.position_lng,
            lat: this.divlist.position_lat,
            alt: this.divlist.position_alt,
            address: this.divlist.address,
            remarks: this.divlist.remarks,
            week: dayjs(
              d.time.slice(0, 4) +
                "-" +
                d.time.slice(4, 6) +
                "-" +
                d.time.slice(6, 8)
            ).day(0),
            time:
              d.time.slice(0, 4) +
              "/" +
              d.time.slice(4, 6) +
              "/" +
              d.time.slice(6, 8) +
              "  " +
              d.time.slice(8, 10) +
              ":" +
              d.time.slice(10, 12),
            tempf: d.tempf,
            tempinf: d.tempinf,
            baromabsin: d.baromabsin,
            baromrelin: d.baromrelin,
            maxdailygust: d.maxdailygust,
            windgustmph: d.windgustmph,
            windspeedmph: d.windspeedmph,
            windspdmph_avg2m: d.windspdmph_avg2m,
            windspdmph_avg10m: d.windspdmph_avg10m,
            minutesrainin: d.minutesrainin,
            hourlyrainin: d.hourlyrainin,
            dailyrainin: d.dailyrainin,
            weeklyrainin: d.weeklyrainin,
            monthlyrainin: d.monthlyrainin,
            yearlyrainin: d.yearlyrainin,
            totalrainin: d.totalrainin,
          };
          this.getHistory(device);
        });
    },

    getHistory(device) {
      let [startTime, endTime] = this.timerange;
      let type = this.period === "week" ? 2 : this.period === "day" ? 1 : 3;
      return $device
        .weatherDetail({
          device: device,
          startTime,
          endTime,
          period: this.period,
          type,
        })
        .then((res) => {
          let data = res.data;
          this.charts.pastChartOption.xAxis[0].data = data.map((d) => d.time);
          this.charts.pastChartOption.series[0].data = data.map(
            (d) => d.tempOut
          );
          this.charts.pastChartOption.series[1].data = data.map(
            (d) => d.humidityOut
          );
          this.charts.pastChartOption.series[2].data = data.map(
            (d) => d.solarRadiation
          );
          this.charts.pastChartOption.series[3].data = data.map((d) => d.rain);
          this.charts.pastChartOption.series[4].data = data.map(
            (d) => d.hpaAbs
          );
          this.charts.pastChartOption.series[5].data = data.map(
            (d) => d.windSpeed
          );
          this.charts.chartOption1.xAxis.data = data.map((d) => d.time);
          this.charts.chartOption1.series[0].data = data.map((d) => d.tempIn);
          this.charts.chartOption1.series[1].data = data.map((d) => d.tempOut);
          this.charts.chartOption2.xAxis.data = data.map((d) => d.time);
          this.charts.chartOption2.series[0].data = data.map(
            (d) => d.humidityIn
          );
          this.charts.chartOption2.series[1].data = data.map(
            (d) => d.humidityOut
          );
          this.charts.chartOption3.xAxis.data = data.map((d) => d.time);
          this.charts.chartOption3.series[0].data = data.map((d) => d.hpaAbs);
          this.charts.chartOption4.xAxis.data = data.map((d) => d.time);
          this.charts.chartOption4.series[0].data = data.map(
            (d) => d.windSpeed
          );
          this.charts.chartOption41.xAxis.data = data.map((d) => d.time);
          this.charts.chartOption41.series[0].data = data.map((d) => d.windDir);
          this.charts.chartOption5.xAxis.data = data.map((d) => d.time);
          this.charts.chartOption5.series[0].data = data.map((d) => d.rain);
          this.charts.chartOption6.xAxis.data = data.map((d) => d.time);
          this.charts.chartOption6.series[0].data = data.map(
            (d) => d.solarRadiation
          );
          this.charts.chartOption7.xAxis.data = data.map((d) => d.time);
          this.charts.chartOption7.series[0].data = data.map((d) => d.uv);
        });
    },

    async getYesTableData(device) {
      let params = {};
      params.startTime = dayjs().subtract(1, "day").format("YYYYMMDD000000");
      params.endTime = dayjs().subtract(1, "day").format("YYYYMMDD000000");
      params.device = device;
      let params2 = {};
      params2.startTime = dayjs().startOf("month").format("YYYYMMDD000000");
      params2.endTime = dayjs().format("YYYYMMDD000000");
      params2.type = 3;
      params2.device = device;
      let res = await $device.getMaxAndMinTem(params);
      let res2 = await $device.weatherDetail(params2);
      if (res.code !== 200 && res2.code !== 200) return;

      let obj =
        res2.data.find(
          (v) => v.time == dayjs().subtract(1, "day").format("YYYYMMDD000000")
        ) || {};
      let yesArr = [
        {
          name: "气温(°C)",
          maxNum: "",
          minNum: "",
          maxTime: "",
          minTime: "",
          avg: obj.tempOut,
        },
        {
          name: "湿度(%)",
          maxNum: "",
          minNum: "",
          maxTime: "",
          minTime: "",
          avg: obj.humidityOut,
        },
        {
          name: "气压(hPa)",
          maxNum: "",
          minNum: "",
          maxTime: "",
          minTime: "",
          avg: obj.hpaAbs,
        },
        {
          name: "风速(m/s)",
          maxNum: "",
          minNum: "",
          maxTime: "",
          minTime: "",
          avg: obj.windSpeed,
        },
        {
          name: "太阳辐射(W/m²)",
          maxNum: "",
          minNum: "",
          maxTime: "",
          minTime: "",
          avg: obj.solarRadiation,
        },
        {
          name: "紫外线强度(0-15)",
          maxNum: "",
          maxTime: "",
          minNum: "",
          minTime: "",
          avg: obj.uv,
        },
        {
          name: "当天降雨(mm)",
          maxNum: obj.rain * 1,
          maxTime: obj.rain * 1,
          minNum: obj.rain * 1,
          minTime: obj.rain * 1,
          avg: obj.rain * 1,
        },
      ];

      res.data.forEach((item) => {
        let curItem = yesArr[item.type - 1];
        if (curItem) {
          let timeFormatted =
            (item.time + "").slice(8, 10) +
            ":" +
            (item.time + "").slice(10, 12);
          if (item.statType === 1) {
            curItem.maxNum = item.dayVal;
            curItem.maxTime = timeFormatted;
          } else {
            curItem.minNum = item.dayVal;
            curItem.minTime = timeFormatted;
          }
        }
      });
      this.yesTableList = yesArr;
    },
  },
};
</script>

<style lang="less" scoped>
.center {
  width: 1420px;
  margin: 0 auto;
}

@media (max-width: 1920px) {
  .center {
    width: 1420px;
  }
}

@media (max-width: 1680px) {
  .center {
    width: 1280px;
  }
}

@media (max-width: 1280px) {
  .center {
    width: 100%;
  }
}

:deep(.el-table) {
  font-size: 20px !important;
}

.page {
  width: 100%;
  height: 100%;
  font-family: "微软雅黑";

  .top {
    .box {
      display: flex;
      justify-content: space-between;
      padding-bottom: 20px;
      border-bottom: 1px solid #e3e3e3;

      .left {
        color: #666;

        h1 {
          font-size: 40px;
          margin: 10px 0;
        }

        h3 {
          font-size: 20px;
          margin: 15px 0;
        }

        p {
          font-size: 14px;
        }
      }

      .right {
        .nav {
          height: 100%;
          display: flex;
          align-items: flex-end;

          div {
            margin-top: 1px;
            color: #fff;
            padding: 10px 15px;
            background-color: #08b;
            margin-right: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            .map {
              width: 100%;
              height: 500px;
            }

            img {
              width: 20px;
              height: 20px;
              margin-right: 5px;
            }
          }

          .o78k {
            background-color: rgb(2, 48, 100) !important;
          }
        }
      }
    }
  }
}

.pageuser {
  width: 100%;

  .inmain {
    padding-top: 100px;

    .box {
      display: flex;
      justify-content: space-between;

      .left {
        width: 40%;

        .in_xian {
          height: 1px;
          width: 100%;
          border-bottom: 1px solid #e3e3e3;
          margin: 10px 0;
        }

        ul {
          color: #666;
          display: flex;
          flex-direction: column;

          li {
            display: flex;
            justify-content: space-between;

            span {
              font-size: 16px;
              line-height: 40px;
            }

            span:nth-child(1) {
              width: 130px;
              text-align: end;
            }

            span:nth-child(2) {
              flex: 1;
              margin-left: 100px;
              font-weight: 600;
            }

            .j_w_color {
              color: #08b;
            }
          }
        }
      }

      .right {
        width: 50%;
        display: flex;
        flex-direction: column;
        color: #666;

        .top {
          display: flex;
          margin-bottom: 20px;
          justify-content: space-between;

          div {
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            p {
              flex: 1;
              display: flex;
              align-items: center;
              margin: 5px 0;
            }

            img {
              width: 20px;
              margin-right: 5px;
            }
          }
        }
      }
    }
  }
}

.pagedata {
  .btn {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0;

    div {
      padding: 0 5px;
    }
  }

  .from {
    .title {
      h3 {
        color: #666;
        font-size: 24px;
        position: relative;
        top: 20px;
      }
    }
  }

  .chart {
    width: 100%;
    height: 350px;
  }
}

.pagemainlist {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 50px;

  > div {
    .chart {
      width: 300px;
      height: 300px;
    }

    position: relative;

    p {
      position: absolute;
      bottom: 10px;
      font-size: 30px;
      left: 50%;
      transform: translate(-50%);
      white-space: nowrap;
    }
  }
}

.znz {
  width: 300px;
  height: 300px;
  background-image: url("../../assets/znz.png");
  background-size: 90% 90%;
  background-repeat: no-repeat;
  background-position: center top;
}

.zhiz {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 5px solid #fff;
  position: relative;
  left: calc(50% - 50px);
  top: calc(45% - 50px);
  text-align: center;
  line-height: 100px;
  font-size: 20px;
  color: #fff;
}

.zhiz::before {
  content: "";
  display: block;
  width: 0;
  height: 0;
  border-bottom: 20px solid rgba(255, 0, 0, 0);
  border-left: 50px solid rgb(255, 187, 0);
  border-top: 20px solid rgba(17, 0, 255, 0);
  position: absolute;
  top: -53px;
  left: 24%;
  transform: rotate(-90deg);
}

.nubone {
  width: 100px;
  height: 26px;
  text-align: center;
  font-size: 26px;
  color: #fff;
  display: block;
  position: absolute;
  top: calc(50% - 13px);
  left: calc(50%);
  transform: translate(-50%, -50%);
}

.pyramid {
  width: 200px;
  height: 200px;
  clip-path: polygon(100% 0%, 50% 89%, 0% 0%);
  transform: rotate(-180deg);
  margin: 0 auto;

  .pyramid_item {
    margin-top: 2px;
    background: #ededed;
    height: 10px;
  }
}

.circle {
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 0 auto;
  margin-top: 30px;
  background: linear-gradient(to bottom, #a9d7b9, #4cb8b9);
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.4);

  .inner {
    width: 185px;
    height: 185px;
    border-radius: 50%;
    background: #fff;
    text-align: center;
    line-height: 185px;
    font-size: 48px;
    color: #5cba7b;
  }
}

.buttom {
  flex: 1;
  display: flex;

  div {
    flex: 1;
    height: 380px;

    img {
      width: 100%;
    }
  }

  ul {
    width: 60px;

    li {
      margin: 0 0 5px 2px;
      box-sizing: border-box;
      border: 1px solid #666;
      width: 100%;
      height: 30px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
    }

    li:hover {
      background-color: #08b;
      color: #fff;
    }
  }
}
</style>
